import React, { createContext, useContext, useState, ReactNode } from 'react';

interface StudentContextType {
  isAddingStudent: boolean;
  setIsAddingStudent: (isAdding: boolean) => void;
  handleBackFromAddStudent: () => void;
  setBackHandler: (handler: () => void) => void;
}

const StudentContext = createContext<StudentContextType | undefined>(undefined);

export const useStudentContext = () => {
  const context = useContext(StudentContext);
  if (!context) {
    throw new Error('useStudentContext must be used within a StudentProvider');
  }
  return context;
};

interface StudentProviderProps {
  children: ReactNode;
}

export const StudentProvider: React.FC<StudentProviderProps> = ({ children }) => {
  const [isAddingStudent, setIsAddingStudent] = useState(false);
  const [backHandler, setBackHandler] = useState<() => void>(() => () => {});

  const handleBackFromAddStudent = () => {
    backHandler();
  };

  return (
    <StudentContext.Provider
      value={{
        isAddingStudent,
        setIsAddingStudent,
        handleBackFromAddStudent,
        setBackHandler,
      }}
    >
      {children}
    </StudentContext.Provider>
  );
};
